import React from 'react';

import {useDataValue} from 'globals/contexts/dataContext';

import LandingSection from 'containers/indexPage/landingSection';
import AboutSection from 'containers/indexPage/aboutSection';
import EventSection from 'containers/indexPage/eventSection';
import ShowcaseSection from 'containers/indexPage/showcaseSection';
import CollaborationSection from 'containers/indexPage/collaborationSection';
import BannerSection from 'containers/indexPage/bannerSection';

import Footer from 'containers/footer';

import './indexPage.css';

const IndexPage = () => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const pageContent = content['content'][currentLanguage]['pages']['index'];
  return <div id="index" className="page">
    <LandingSection content={pageContent['landing']} />
    <AboutSection content={pageContent['about']} />
    <EventSection content={pageContent['event']} />
    <ShowcaseSection content={pageContent['showcase']} />
    <CollaborationSection content={pageContent['collaboration']} />
    <BannerSection content={pageContent['banner']} />
    <Footer />
  </div>
}

export default IndexPage;